import { FilterOption, FilterOptionGroup, FilterSelectionGroup } from '../types/filter';

/** Identifies dropdown configuration groups containing available `options`. */
export function isFilterOptionGroup<T, K extends keyof T>(
  option: FilterOption<T, K>
): option is FilterOptionGroup<T, K> {
  return (
    typeof option === 'object' && 'groupName' in option && 'options' in option
  );
}

export function hasGroup<T, K extends keyof T>(
  options: FilterOption<T, K>[]
): boolean {
  return options.some((option) => isFilterOptionGroup(option));
}

/** Identifies applied selection groups containing selected `filters`, rather than UI options. */
export function isFilterSelectionGroup<T, K extends keyof T>(
  value: T[K] | FilterSelectionGroup<T, K>,
): value is FilterSelectionGroup<T, K> {
  return (
    typeof value === 'object' &&
    value !== null &&
    'groupName' in value &&
    'filters' in value
  );
}
